module.exports = "/img/_/_/_/assets/images/creeper/battle/common//22.jpg?d6170d96f2abe6d274b4f9f9211c4bcf";